import { ExportTo } from '../../modules/ExportTo';
import { pdfcss as pdfcssregular } from '../../modules/ProductApproval/pdfcss';
import { pdfcss } from '../../modules/ProductApprovalShort/pdfcss';

export const approvalPdfDialog = (function () {
  let open = (id) => {
    let template = require('./tmpl/dialog/approvalAsPdf.hbs');
    bootbox.dialog({
      title: $lang.approvalAsPDF.DownloadapprovalasPDF,
      message: template({ $lang: $lang }),
      size: 'large',
      buttons: {
        download: {
          label: $lang.btn.download,
          className: 'btn bbw-border-radius btn-primary',
          callback: (e) => {
            let type = $('.approval-as-pdf-form [name="formtype"]:checked').val();
            if (type == 'regular') {
              exportPdfRegular(id);
            } else {
              exportPdfShort(id);
            }
          }
        },
        cancel: {
          label: $lang.btn.cancel,
          className: 'btn bbw-border-radius btn-link'
        }
      }
    });
  };

  let exportPdfShort = (id) => {
    ExportTo.pdf({
      selector: '#productApprovalCard-short',
      css: pdfcss,
      filename: id,
      orientation: 'landscape',
      iframeurl: `/prelistings/${id}/productApprovalShort`
    });
  };

  let exportPdfRegular = (id) => {
    ExportTo.pdf({
      css: pdfcssregular,
      filename: id,
      iframeurl: `/prelistings/${id}/productApprovalRegular`
    });
  };

  return {
    open
  };
})();
